import posthog from "posthog-js"

export const onClientEntry = () => {
  const apiKey = process.env.GATSBY_POSTHOG_API_KEY
  const host = process.env.GATSBY_POSTHOG_HOST

  if (!apiKey || !host) return

  posthog.init(apiKey, {
    api_host: host,
    persistence: "memory",
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: true,
    scroll_depth: true,
  })
}

export const onRouteUpdate = ({ location }) => {
  if (typeof posthog !== "undefined") {
    posthog.capture("$pageview", {
      $current_url: location.href,
    })
  }
}
